// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__DmgJs","container_title":"Title_container_title__d1hM7"};